<template>
    <div class="container-login form-login-meio">
        <div class="p-d-flex p-jc-center"> 
            <div>
                <div class="p-d-flex p-jc-center p-mb-5">
                    <a href="/login">
                        <img alt="Logo" src="@/assets/logo.png" />
                    </a>
                </div>
                <div class="card p-fluid p-shadow-3" style="width: 25rem;">
                    <h5 class="p-text-bold p-pt-4">Login Adm</h5>
                    <div class="p-field p-mt-4">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-user"/>                       
                            <InputText v-model.trim="usuario.email" type="text" placeholder="Email" aria-describedby="email-erro" />                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="exibirErroEmail">Informe o email</small>  
                    </div>
                    <div class="p-field">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-lock" />
                            <InputText v-model.trim="usuario.senha" type="password" placeholder="Senha" 
                            v-on:keyup.enter="login" aria-describedby="senha-erro"/>                            
                        </span>          
                        <small id="senha-erro" class="p-invalid" v-if="exibirErroSenha">Informe a senha</small>                                                              
                    </div>   
                    <div class="p-grid p-mt-3 p-mb-4">
                        <div class="p-col-12">
                            <Button label="Login" @click="login"/>
                        </div>
                    </div>	
                    <Message severity="error" v-if="exibirErro">{{ mensagemErro }}</Message>
                </div>
                <div class="p-text-center" style="color:#F9B720">Info Kings</div>
                <div v-if="exibirSpin" class="p-text-center"><i class="pi pi-spin pi-spinner" style="fontSize: 2rem; color:#F9B720"></i></div>
            </div>
        </div>
    </div> 
</template>

<script>
import LoginService from '@/service/LoginService';
import LoginIKAcessoService from '@/service/LoginIKAcessoService';
import { mapActions } from 'vuex';
import http from '@/plugins/axios/axios';
import { CHAVE_USUARIO, CHVAE_TOKEN } from '@/global';

export default {
    loginService: null,
    loginIKAcessoService: null,
    data() {
        return {
            exibirSpin: false,
            exibirErroEmail: false,
            exibirErroSenha: false,
            mensagemErro: '',
            exibirErro: false,
            usuario: {
                email: '',
                senha: ''
            }
        }
    },    
    methods: {
        ...mapActions('sessao', ['criarSessao', 'criarSessaoIKAcesso']),
        login() {
            this.exibirSpin = true;
            this.exibirErro = false;
            this.exibirErroEmail = false;
            this.exibirErroSenha = false;
            if(this.usuario.email == '') {
                this.exibirErroEmail = true;
            }
            if(this.usuario.senha == '') {
                this.exibirErroSenha = true;
            }
            if(!this.exibirErroEmail && !this.exibirErroSenha) {            
                this.loginService.autenticar(this.usuario)
                    .then(resp => {                         
                        // Header do axios
                        http.defaults.headers.common['Authorization'] = 'Bearer '+resp.data.token.valor;
                        this.criarSessao(resp.data);    
                        this.exibirSpin = false;                                             
                        this.$router.push('/dashboard');       
                        //this.loginIKAcesso(resp.data);                      
                    })
                    .catch(erro => {       
                        this.exibirSpin = false;                 
                        this.exibirErro = true;
                        if(erro.response.status == 400) {
                            this.mensagemErro = erro.response.data.mensagem;
                        } else {
                            this.mensagemErro = erro.response.data.mensagem;
                        }
                    });               
            } else {
                this.exibirSpin = false;
            }           
        },
        loginIKAcesso(dadosIKPonto) {
            this.exibirSpin = true;
            this.exibirErro = false;            
            this.loginIKAcessoService.autenticar(this.usuario)
                .then(resp => {
                    this.usuario = {};                  
                    this.criarSessaoIKAcesso(resp.data);                                     
                    this.$router.push('/');                            
                })
                .catch(() => {       
                    this.exibirSpin = false;
                })
                .finally(() => {
                    this.exibirSpin = false;
                    this.criarSessao(dadosIKPonto);          
                });            
        },
        /**
         * 
         */
        async validarToken() {                  
            let token = JSON.parse(sessionStorage.getItem(CHVAE_TOKEN)); 
            if(!token) {   
                sessionStorage.clear();                                       
                return   
            } 
            http.defaults.headers.common['Authorization'] = 'Bearer '+token.valor;               
            this.criarSessao(JSON.parse(sessionStorage.getItem(CHAVE_USUARIO)));   
            this.$router.push({ path: '/dashboard' });     
        },        
    },
    created() {
        this.loginService = new LoginService();
        this.loginIKAcessoService = new LoginIKAcessoService();        
        this.validarToken();
    }
}
</script>

<style scoped>    
    
    html, body {
        height: 100vh !important;
        margin: 0px !important;  
    }

    .container-login {
        height: 100vh !important;
        background-color: #232839 !important;
    }

    .form-login-meio {
        padding-top: 130px;
    }

    .text-help {
        font-size: 0.9rem !important;
    }

</style>